var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showTitle)?_c('div',{staticClass:"my-1"},[_vm._v("Company")]):_vm._e(),(_vm.companies && _vm.companies.length)?_c('SelectDropdown',{attrs:{"id":`company`,"options":_vm.companiesFiltered,"multiple":false,"field":"company","value":_vm.companyId},on:{"change":_vm.handleCompanyChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }